import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export default function UserRoute() {
  const { dataUser } = useContext(AuthContext);

  return dataUser?.user ? <Outlet /> : <Navigate to="/login" />;
}
